export default __webpack_public_path__ + "static/media/doctor-giving-presentation-team-interim-doctors (1) (1).42c8801d.jpg";